"use client";

import { c as _c } from "react/compiler-runtime";
import Cookies from "js-cookie";
import dynamic from "next/dynamic";
import { useSyncExternalStore } from "react";
import FooterSkeleton from "@/app/(fevicol-inhomz)/_components/FooterSkeleton";
const Footer = dynamic(() => import("@/app/(fevicol-inhomz)/_components/Footer"), {
  ssr: false,
  loading: () => <FooterSkeleton />
});
const subscribe = () => () => {};
const getIsWebview = () => Cookies.get("webview") === "true";
const getServerIsWebview = () => null;

/**
 * OnlyWebFooter
 *
 * Renders the Fevicol Interior Experts footer on the web, and nothing inside
 * the native webview (the app provides its own navigation). The webview cookie
 * is only readable on the client, so the skeleton holds the space until mount
 * decides, and the footer chunk is never loaded in the webview.
 */
export default function OnlyWebFooter() {
  const $ = _c(2);
  const isWebview = useSyncExternalStore(subscribe, getIsWebview, getServerIsWebview);
  if (isWebview === null) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <FooterSkeleton />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (isWebview) {
    return null;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Footer />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}